import React from 'react';

interface OrientationCheckOverlayProps {
  isMirrored: boolean;
  onSelectOrientation: (isMirrored: boolean) => void;
  onConfirm: () => void;
}

const OrientationCheckOverlay: React.FC<OrientationCheckOverlayProps> = ({
  isMirrored,
  onSelectOrientation,
  onConfirm
}) => {
  return (
    <div className="orientation-check-overlay" role="dialog" aria-label="Check direction before practice">
      <div className="orientation-check-title">Check direction before practice</div>
      <div className="orientation-check-options" aria-label="Practice direction">
        <button
          type="button"
          className={`orientation-check-option orientation-check-option-original ${!isMirrored ? 'is-selected' : ''}`}
          aria-pressed={!isMirrored}
          onClick={() => onSelectOrientation(false)}
        >
          Original
        </button>
        <button
          type="button"
          className={`orientation-check-option orientation-check-option-mirrored ${isMirrored ? 'is-selected' : ''}`}
          aria-pressed={isMirrored}
          onClick={() => onSelectOrientation(true)}
        >
          Mirrored
        </button>
      </div>
      <button
        type="button"
        className="orientation-check-confirm"
        onClick={onConfirm}
      >
        Looks right
      </button>
    </div>
  );
};

export default OrientationCheckOverlay;
